import React, { useEffect, useState } from 'react';

const rs = v => (v < 0 ? '-' : '+') + '₹' + Math.abs(Math.round(v)).toLocaleString('en-IN');
const n0 = v => Math.round(v).toLocaleString('en-IN');

export default function FOLive() {
  const [d, setD] = useState(null);
  useEffect(() => { let on = true;
    const load = () => fetch('/fo/live').then(r => r.json()).then(x => on && setD(x)).catch(() => {});
    load(); const id = setInterval(load, 30000); return () => { on = false; clearInterval(id); }; }, []);
  if (!d || d.error || d.nifty == null) return null;
  return (
    <div style={{ background: '#fff', border: '1px solid #C7C9F2', borderRadius: 12, padding: 14, marginBottom: 16 }}>
      <div style={{ display: 'flex', flexWrap: 'wrap', gap: 14, alignItems: 'baseline' }}>
        <span style={{ background: '#3730A3', color: '#fff', borderRadius: 6, padding: '2px 8px', fontSize: 12, fontWeight: 700 }}>LIVE {d.at}</span>
        <span style={{ fontSize: 18, fontWeight: 700 }}>NIFTY {n0(d.nifty)}</span>
        <span style={{ fontSize: 13, color: '#5E5B55' }}>Display only: breaches, targets and stops are judged at the 15:25 close.</span>
      </div>
      {d.structures.map(s => <div key={s.id} style={{ marginTop: 8, fontSize: 15 }}>
        <b>#{s.id}</b> · live P&amp;L <span style={{ color: s.pnl >= 0 ? '#11663A' : '#B42318', fontWeight: 700 }}>{rs(s.pnl)}</span>
        {s.where ? ` · NIFTY is ${s.where}` : ''}{s.complete ? '' : ' · some legs have no live price yet'}</div>)}
    </div>);
}
